export default {
    text: {
        fontFamily: "'Open Sans', sans-serif",
        color: '#222',
        fontSize: '17px',
        margin: 0,
        height: 'max-content'
    },
    overflowEllipsis: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    secondaryFont: {
        fontFamily: "'Lato', sans-serif"
    },
    bold: {
        fontWeight: 'bold'
    },
    extraBold: {
        fontWeight: 800
    },
    ultraBold: {
        fontWeight: 900
    },
    extraSmall: {
        fontSize: '12px'
    },
    small: {
        fontSize: '14px'
    },
    medium: {
        fontSize: '17px'
    },
    large: {
        fontSize: '20px'
    },
    white: {
        color: '#fff'
    }
};
//# sourceMappingURL=styles.js.map